/**
 * Initialize custom form elements on every select and checkbox element, always, forever.
 *
 * @author Todd Miller <todd.miller@tricomb2b.com>
 */

import customSelect from 'custom-select';

(function ($) {
  'use strict';

  Drupal.behaviors.initializeCustomSelectBoxes = {
    attach: (context) => {
      if (context === document) initialize();
      else if ($(context).is('form')) initialize(context);
      else if ($(context).hasClass('webform-ajax-form-wrapper'))
        initialize(context);
    },
  };

  /**
   * Attach the custom select box to all <select>s, using the given
   * context if provided.
   */
  function initialize(context = null) {
    if (context) {
      const $boxes = $('input[type="checkbox"]:not(.form-checkbox)', context);
      $boxes.wrap('<div class="checkbox-wrap"></div>').after('<div></div>');

      customSelect('select', context);
    } else {
      const $boxes = $('input[type="checkbox"]:not(.form-checkbox)');
      $boxes.wrap('<div class="checkbox-wrap"></div>').after('<div></div>');

      customSelect('select');
    }
  }
})(jQuery);
